import { AfterViewInit, Component } from '@angular/core';
import { NgbActiveModal } from '@cmps/ng-bootstrap';

import { TranslationKeyMap } from './auth.i18n';

@Component({
    selector: 'cmps-auth-login-modal',
    templateUrl: './modal.login.auth.component.html',
})
export class LoginModalAuthComponent implements AfterViewInit {
    i18n = TranslationKeyMap;

    constructor(public activeModal: NgbActiveModal) {}

    ngAfterViewInit(): void {
        // TODO revise
        // all other modals should have been dismissed
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unnecessary-type-assertion
        const el = <HTMLElement>document.querySelector('ngb-modal-backdrop');
        if (el) {
            el.style.opacity = 'inherit';
            el.style.backgroundColor = getComputedStyle(
                document.body,
            ).backgroundColor;
        }
    }
}
